const AUTH_TOKEN_KEY = 'aktif_auth_token';
const AUTH_ROLE_KEY = 'aktif_auth_role';

export function getStoredRole() {
  return localStorage.getItem(AUTH_ROLE_KEY);
}

export function getStoredToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function setStoredAuth({ token, role }) {
  if (token) localStorage.setItem(AUTH_TOKEN_KEY, token);
  if (role) localStorage.setItem(AUTH_ROLE_KEY, role);
}

export function setStoredRole(role) {
  localStorage.setItem(AUTH_ROLE_KEY, role);
}

export function clearStoredRole() {
  localStorage.removeItem(AUTH_ROLE_KEY);
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function isAdminRole(role) {
  return role === 'admin';
}

export function maskPhoneNumber(phone) {
  if (!phone || phone === '—') return '—';
  const s = String(phone);
  if (s.length <= 4) return '****';
  return `${s.slice(0, 3)}***${s.slice(-2)}`;
}
